import type { RouterContext } from '@atlassian/react-resource-router';

/** Return `true` if the route is using a chromeless layout, meaning no navigation is visible. */
export const isChromelessRoute = ({ route }: RouterContext): boolean => {
	return route.layout?.isChromeless ?? false;
};
